module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "waiting-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("待機室")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": _vm.deleteRoom
    }
  }, [_vm._v("ルームを削除\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("基本情報")]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ルーム名")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.roomName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("開始時刻")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.startTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("テーマ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("カードコピー機能")]), _vm._v(" "), (_vm.info.isCopy) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("あり")]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("なし")])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("手札公開")]), _vm._v(" "), (_vm.info.isPublic) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("公開")]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("非公開")])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人数")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.peopleNumber) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "item row m-column url-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("招待URL")]), _vm._v(" "), _c('div', {
    staticClass: "text row"
  }, [_c('div', {
    staticClass: "url-text"
  }, [_vm._v(_vm._s(_vm.info.url))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copyInfo),
      expression: "copyInfo",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "copy-btn",
    attrs: {
      "id": "copy-btn"
    }
  }, [_vm._v("\n\t\t\t\t\tコピーする\n\t\t\t\t")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("参加人員(プレイヤー設定)")]), _vm._v(" "), _c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.lists), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [(_vm.info.homeowner == item.id) ? _c('i', {
      staticClass: "el-icon-setting"
    }) : _vm._e(), _vm._v(" "), _c('el-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.checked),
        expression: "item.checked"
      }],
      staticClass: "item",
      attrs: {
        "value": item.sort,
        "type": "primary"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), (_vm.info.homeowner == item.id) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("ファシリテーター")]) : _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.startGame()
      }
    }
  }, [_vm._v("スタート")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert"
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12630a7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Waiting.vue
// module id = 881
// module chunks = 1